// src/services/screens.service.js
import api from "@/api/axios";

export async function getScreens() {
  const response = await api.get("/screens");
  return response.data;
}